export class TimeTypes {
  static ALL = 'all'
  static ONE = 'one'
  static PERMANENT = 'permanent'
  static MATERIAL = 'material'
  static NONE = 'none'
  static TEMP = 'temp'
}
